const WORDS = [
  "Tranquilidad",
  "Organización",
  "Confianza",
  "Bienestar",
  "Serenidad",
  "Cuidado",
];

export default function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="bg-[#F6F1E7] py-10 md:py-14 overflow-hidden border-y border-[#EBEBEB]"
    >
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-display text-4xl md:text-6xl text-[#2D3732] px-8 font-light">
              {w}
            </span>
            <span className="text-[#A3B18A] text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
